export const FirebaseConfig = {
	"projectId": "errandify-ceb20",
	"appId": "1:249051454129:web:7637dd33924cbb2c7e2090",
	"databaseURL": "https://errandify-ceb20-default-rtdb.firebaseio.com",
	"storageBucket": "errandify-ceb20.firebasestorage.app",
	"apiKey": "AIzaSyD6LPonDU_s4OK47C_99kD46bPajO8kQxU",
	"authDomain": "errandify-ceb20.firebaseapp.com",
	"messagingSenderId": "249051454129",
	"measurementId": "G-KZY8LY7M82",
	"projectNumber": "249051454129",
	"version": "2"
};